import { memo } from "react";
import Chip from "@mui/material/Chip";
import type { AdmissionRecheckOutcome } from "../../../../lib/corpusApi";

const OUTCOME_MAP: Record<
  AdmissionRecheckOutcome,
  { label: string; color: "default" | "success" | "error" | "warning" }
> = {
  admitted: { label: "Admitted", color: "success" },
  rejected: { label: "Rejected", color: "error" },
  escalated: { label: "Escalated", color: "warning" },
  skipped: { label: "Skipped", color: "default" },
};

export interface AdmissionOutcomeBadgeProps {
  outcome: AdmissionRecheckOutcome;
}

/** Chip rendering what the admission gate decided for a document. */
export const AdmissionOutcomeBadge = memo(function AdmissionOutcomeBadge({
  outcome,
}: AdmissionOutcomeBadgeProps) {
  const { label, color } = OUTCOME_MAP[outcome];
  return <Chip label={label} color={color} size="small" />;
});
